/**
 * URL base del backend (sin barra final).
 * CRA: definir en .env como REACT_APP_API_BASE_URL=http://localhost:3300
 */
export function getApiBaseUrl() {
  const raw = String(process.env.REACT_APP_API_BASE_URL || "").trim();

  // "/" significa MISMO ORIGEN: las llamadas salen como /api/v1/... y las
  // atiende quien sirve la página, que las reenvía al backend.
  //
  // Existe porque desde China hay redes que no alcanzan el dominio del backend
  // en Fly, aunque sí carguen dtenrs.cl (que va por Amazon). El navegador veía
  // "Failed to fetch" al iniciar sesión: la petición nunca llegaba. Pasando por
  // el mismo origen, el tráfico va donde la persona sí tiene acceso.
  if (raw === "/") {
    return "";
  }

  if (raw) {
    return raw.replace(/\/$/, "");
  }
  return "https://facturacion-electronica-node.fly.dev";
}
